export const FindDocument = {
  FindDocument: {
    path: '/document/find/:cabinetId',
    name: 'findDocument'
  }
};
